module.exports = __webpack_public_path__ + "static/media/rebellion mk II.2d13b43b.png";